module.exports = __webpack_public_path__ + "img/preview.7513c7b4.png";